/// Auto-generated with ScanbotSDKCodegenV3. Modifications will be overwritten.
/// Generated from rtu-ui-v2/schemas/mrz/MRZScannerScreenConfiguration.yaml
import { AspectRatio } from '../../geometry/Geometry';
import { MrzScannerConfiguration } from '../../mrz/MrzTypes';
import { ActionBarConfiguration } from '../common/ActionBarConfiguration';
import { CameraConfiguration } from '../common/CameraConfiguration';
import { CameraPermissionScreen } from '../common/CameraPermission';
import { BackgroundStyle, ButtonConfiguration, EdgeInsets, ForegroundStyle, IconButton, IconStyle, Palette, RoundButton, Sound, StyledText, Vibration, } from '../common/Common';
import { ScanCompletionOverlay } from '../common/ScanCompletionOverlay';
import { TopBarConfiguration } from '../common/TopBarConfiguration';
import { UserGuidanceConfiguration } from '../common/UserGuidanceConfiguration';
import { FinderCorneredStyle, PermanentViewFinderConfiguration } from '../common/ViewFinderConfiguration';
import { MrzFinderLayoutPreset, TwoLineMrzFinderLayoutPreset } from './MrzFinderLayoutPreset';
import { MrzScannerIntroScreenConfiguration } from './MrzScannerIntroScreenConfiguration';
import { MrzScannerScreenTextLocalization } from './MrzScannerScreenTextLocalization';
/**
Configuration of the screen for detecting MRZ (Machine-readable zones) of various documents.
*/
export class MrzScannerScreenConfiguration {
    /** @param source {@displayType `DeepPartial<MrzScannerScreenConfiguration>`} */
    constructor(source = {}) {
        /**
          Version number of the configuration object.
          
          Default is "1.0"
          */
        this.version = '1.0';
        /**
          The configuration object should be applied for this screen.
          
          Default is "MrzScanner"
          */
        this.screen = 'MrzScanner';
        /**
          Configuration of the all strings for MRZ scanner screen.
          */
        this.localization = new MrzScannerScreenTextLocalization({});
        /**
          Define the screen's base color values from which other colors are derived.
          */
        this.palette = new Palette({});
        /**
          The background color of the MRZ scanner screen.
          
          Default is "?sbColorSurfaceLow"
          */
        this.backgroundColor = '?sbColorSurfaceLow';
        /**
          Configuration of the camera behavior.
          */
        this.cameraConfiguration = new CameraConfiguration({ orientationLockMode: 'PORTRAIT' });
        /**
          Configuration of the dialog for requesting camera permissions.
          */
        this.cameraPermission = new CameraPermissionScreen({
            statusBarMode: 'DARK',
            background: '?sbColorSurface',
            iconBackground: '?sbColorOutline',
            icon: new IconStyle({ visible: true, color: '?sbColorOnSurface' }),
            enableCameraButton: new ButtonConfiguration({
                visible: true,
                text: '?cameraPermissionEnableCameraButton',
                accessibilityDescription: '?accessibilityDescriptionCameraPermissionEnableCameraButton',
                background: new BackgroundStyle({
                    strokeColor: '?sbColorPrimary',
                    fillColor: '?sbColorPrimary',
                    strokeWidth: 0.0,
                }),
                foreground: new ForegroundStyle({ iconVisible: false, color: '?sbColorOnPrimary', useShadow: false }),
            }),
            closeButton: new ButtonConfiguration({
                visible: true,
                text: '?cameraPermissionCloseButton',
                accessibilityDescription: '?accessibilityDescriptionCameraPermissionCloseButton',
                background: new BackgroundStyle({ strokeColor: '#00000000', fillColor: '#00000000', strokeWidth: 0.0 }),
                foreground: new ForegroundStyle({ iconVisible: false, color: '?sbColorPrimary', useShadow: false }),
            }),
            enableCameraTitle: new StyledText({ text: '?cameraPermissionEnableCameraTitle', color: '?sbColorOnSurface' }),
            enableCameraExplanation: new StyledText({
                text: '?cameraPermissionEnableCameraExplanation',
                color: '?sbColorOnSurfaceVariant',
            }),
        });
        /**
          Configuration of the top user guidance.
          */
        this.topUserGuidance = new UserGuidanceConfiguration({
            title: new StyledText({ text: '?topUserGuidance' }),
        });
        /**
          Configuration of the user guidance below finder view.
          */
        this.finderViewUserGuidance = new UserGuidanceConfiguration({
            title: new StyledText({ text: '?finderViewUserGuidance' }),
        });
        /**
          Configuration of the top bar on the MRZ scanner screen.
          */
        this.topBar = new TopBarConfiguration({
            title: new StyledText({ visible: true, text: '?topBarTitle' }),
            cancelButton: new ButtonConfiguration({
                text: '?topBarCancelButton',
                accessibilityDescription: '?accessibilityDescriptionCancelButton',
                background: new BackgroundStyle({ strokeColor: '#00000000', fillColor: '#00000000', strokeWidth: 0.0 }),
                foreground: new ForegroundStyle({ color: '?sbColorOnPrimary' }),
            }),
        });
        /**
          Configuration of the button in the top bar that opens the introduction screen.
          */
        this.topBarOpenIntroScreenButton = new IconButton({
            color: '?sbColorOnPrimary',
            accessibilityDescription: '?accessibilityDescriptionOpenIntroScreenButton',
        });
        /**
          Configuration of the introduction screen for the MRZ scanner.
          */
        this.introScreen = new MrzScannerIntroScreenConfiguration({});
        /**
          Configuration of the action bar.
          */
        this.actionBar = new ActionBarConfiguration({
            flipCameraButton: new RoundButton({
                visible: false,
                accessibilityDescription: '?accessibilityDescriptionFlipCameraButton',
                accessibilityState: '?accessibilityStateFlipCameraBackButton',
                activeAccessibilityState: '?accessibilityStateFlipCameraFrontButton',
                backgroundColor: '?sbColorSurfaceHigh',
                foregroundColor: '?sbColorOnPrimary',
                activeBackgroundColor: '?sbColorWarning',
                activeForegroundColor: '#1C1B1F',
            }),
        });
        /**
          Configuration of the view finder.
          */
        this.viewFinder = new PermanentViewFinderConfiguration({
            style: new FinderCorneredStyle({ strokeColor: '?sbColorSurface', strokeWidth: 2.0 }),
            aspectRatio: new AspectRatio({ width: -1.0, height: -1.0 }),
            minimumInsets: new EdgeInsets({ top: 24.0, left: 24.0, bottom: 24.0, right: 24.0 }),
        });
        /**
          Configuration of the MRZ scanner.
          */
        this.scannerConfiguration = new MrzScannerConfiguration({});
        /**
          Configuration of the overlay text inside finder.
          */
        this.mrzExampleOverlay = new TwoLineMrzFinderLayoutPreset({});
        /**
          Configuration of the success overlay.
          */
        this.successOverlay = new ScanCompletionOverlay({});
        /**
          Configuration of the scan confirmation sound.
          */
        this.sound = new Sound({});
        /**
          Configuration of the vibration feedback.
          */
        this.vibration = new Vibration({});
        /**
          If enabled, the screen will not turn off while the MRZ scanner is active.
          
          Default is true
          */
        this.keepScreenOn = true;
        if (source.version !== undefined) {
            this.version = source.version;
        }
        if (source.screen !== undefined) {
            this.screen = source.screen;
        }
        if (source.localization !== undefined) {
            this.localization = new MrzScannerScreenTextLocalization(source.localization);
        }
        if (source.palette !== undefined) {
            this.palette = new Palette(source.palette);
        }
        if (source.backgroundColor !== undefined) {
            this.backgroundColor = source.backgroundColor;
        }
        if (source.cameraConfiguration !== undefined) {
            this.cameraConfiguration = new CameraConfiguration(source.cameraConfiguration);
        }
        if (source.cameraPermission !== undefined) {
            this.cameraPermission = new CameraPermissionScreen(source.cameraPermission);
        }
        if (source.topUserGuidance !== undefined) {
            this.topUserGuidance = new UserGuidanceConfiguration(source.topUserGuidance);
        }
        if (source.finderViewUserGuidance !== undefined) {
            this.finderViewUserGuidance = new UserGuidanceConfiguration(source.finderViewUserGuidance);
        }
        if (source.topBar !== undefined) {
            this.topBar = new TopBarConfiguration(source.topBar);
        }
        if (source.topBarOpenIntroScreenButton !== undefined) {
            this.topBarOpenIntroScreenButton = new IconButton(source.topBarOpenIntroScreenButton);
        }
        if (source.introScreen !== undefined) {
            this.introScreen = new MrzScannerIntroScreenConfiguration(source.introScreen);
        }
        if (source.actionBar !== undefined) {
            this.actionBar = new ActionBarConfiguration(source.actionBar);
        }
        if (source.viewFinder !== undefined) {
            this.viewFinder = new PermanentViewFinderConfiguration(source.viewFinder);
        }
        if (source.scannerConfiguration !== undefined) {
            this.scannerConfiguration = new MrzScannerConfiguration(source.scannerConfiguration);
        }
        if (source.mrzExampleOverlay !== undefined) {
            this.mrzExampleOverlay = MrzFinderLayoutPreset.from(source.mrzExampleOverlay);
        }
        if (source.successOverlay !== undefined) {
            this.successOverlay = new ScanCompletionOverlay(source.successOverlay);
        }
        if (source.sound !== undefined) {
            this.sound = new Sound(source.sound);
        }
        if (source.vibration !== undefined) {
            this.vibration = new Vibration(source.vibration);
        }
        if (source.keepScreenOn !== undefined) {
            this.keepScreenOn = source.keepScreenOn;
        }
    }
}
//# sourceMappingURL=MrzScannerScreenConfiguration.js.map